module.exports = __webpack_public_path__ + "static/media/defaultOrangeContainer.c2d97339.svg";